import { useTenantsControllerGetTenant } from "@/api/orval/connect";
import { useGetWhoami } from "@/api/whoami/get-whoami";
import { useOptionalPathTenantId } from "@/hooks/use-path-params";

/** テナント名はほとんど変わらない。画面遷移のたびに取り直さない */
const STALE_TIME_MS = 5 * 60 * 1000;

/**
 * 画面に出してよいテナント名。表示中のテナントは URL が正。
 *
 * ホストは所属を持たないため、URL のテナントを引いて名前にする。
 * ここが空のままだと、どのテナントを操作しているか分からずに
 * 画像やユーザーを消せてしまう。
 *
 * 取得は Suspense に載せない。ヘッダーは全画面で描画されるため、
 * ここで待たせると画面全体の表示が遅れる。名前は取れ次第あとから出る。
 */
export const useCurrentTenantName = (): string | undefined => {
  const pathTenantId = useOptionalPathTenantId();
  const { tenantId, tenantName, isHost } = useGetWhoami();

  const { data } = useTenantsControllerGetTenant(pathTenantId ?? "", {
    query: {
      enabled: isHost && Boolean(pathTenantId),
      staleTime: STALE_TIME_MS,
      retry: false,
    },
  });

  if (!pathTenantId) {
    return undefined;
  }

  if (isHost) {
    return data?.name;
  }

  // 所属外のテナントを開いた場合は名前を出さない
  if (pathTenantId.toLowerCase() !== tenantId?.toLowerCase()) {
    return undefined;
  }

  return tenantName ?? undefined;
};
